"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Desktop = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
const Desktop = _ref => {
  let {
    crumbs,
    onCrumbClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-Breadcrumbs"
  }, crumbs.map((crumb, index) => /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-Breadcrumbs-Item",
    key: (0, _key.createKey)(index, crumb.title)
  }, crumb.url ? /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-Breadcrumbs-Link",
    href: crumb.url,
    onClick: onCrumbClick?.(crumb.url)
  }, crumb.title) : crumb.title)));
};
exports.Desktop = Desktop;
//# sourceMappingURL=Desktop.js.map